import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }

import RichText from "@/components/base/inputs/RichText.vue";
import { useAMPStore } from "@/store/asset-management-plan";


export default /*#__PURE__*/_defineComponent({
  __name: 'Introduction',
  props: {
    readonly: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const store = useAMPStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RichText, {
      modelValue: _unref(store).plan.purpose,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).plan.purpose) = $event)),
      label: "1.1 Purpose",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(RichText, {
      modelValue: _unref(store).plan.executive_summary,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).plan.executive_summary) = $event)),
      label: "1.2 Executive Summary",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"])
  ]))
}
}

})